// @flow

export const addBodyModalClass = () => {
  const { body } = document;
  if (!body) {
    return;
  }
  const { classList } = body;
  if (classList && classList.add) {
    classList.add('modal-open');
  }
};

export const removeBodyModalClass = () => {
  const { body } = document;
  if (!body) {
    return;
  }
  const { classList } = body;
  if (classList && classList.remove) {
    classList.remove('modal-open');
  }
};
